import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95af1920"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-bar" }
const _hoisted_2 = {
  class: "btn-back",
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#offcanvas",
  "aria-controls": "offcanvas"
}
const _hoisted_3 = { class: "navbar-logo" }
const _hoisted_4 = { class: "title-bar-title" }
const _hoisted_5 = { style: {"position":"relative","left":"82%","display":"flex","flex-direction":"row","width":"200px","padding-top":"9px"} }
const _hoisted_6 = { class: "form-check form-switch" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = {
  class: "form-check-label",
  for: "language"
}
const _hoisted_9 = { class: "form-label" }
const _hoisted_10 = {
  class: "form-check form-switch",
  style: {"margin-left":"30px"}
}
const _hoisted_11 = ["checked"]
const _hoisted_12 = {
  class: "form-check-label",
  for: "language"
}
const _hoisted_13 = { class: "form-label" }
const _hoisted_14 = {
  class: "offcanvas offcanvas-start",
  "data-bs-scroll": "true",
  "data-bs-backdrop": "false",
  tabindex: "-1",
  id: "offcanvas"
}
const _hoisted_15 = { class: "offcanvas-header" }
const _hoisted_16 = { class: "header-box" }
const _hoisted_17 = {
  class: "sidebar-close",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}
const _hoisted_18 = { class: "offcanvas-body" }
const _hoisted_19 = ["onClick", "data-bs-target", "aria-controls"]
const _hoisted_20 = { class: "col" }
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "card card-body" }
const _hoisted_23 = { class: "nav flex-column nav-pills" }
const _hoisted_24 = {
  key: 0,
  class: "d-grid"
}
const _hoisted_25 = { class: "col" }
const _hoisted_26 = {
  class: "collapse multi-collapse",
  id: `detail`
}
const _hoisted_27 = { class: "card card-body" }
const _hoisted_28 = { class: "nav flex-column nav-pills" }
const _hoisted_29 = {
  class: "offcanvas-footer",
  style: {"position":"relative","display":"flex","flex-direction":"column","align-items":"center","padding-bottom":"10px"}
}
const _hoisted_30 = { class: "user-box" }
const _hoisted_31 = { class: "user-icon" }
const _hoisted_32 = { class: "user-text" }
const _hoisted_33 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between","margin-top":"20px","width":"288px"} }
const _hoisted_34 = { class: "account-box" }
const _hoisted_35 = { class: "logout-box" }

import { ref, PropType, computed, watchEffect } from "vue";
import _ from "lodash";
import { ROU_NAME } from "@/router/router.name";
import { useRoute, useRouter } from "vue-router";
import AppImageVue from "./AppImage.vue";
import { accountAxios } from "../service/account.service";
import { userUseStore } from "@/store/user";
import { useI18n } from "vue-i18n";
import { adminUseStore } from "@/store/admin";
import { superUseStore } from "@/store/super";
import { deleteCookie } from "@/service/local/cookies.service";
import { userAxios } from "@/service/user.service";
import { adminAxios } from "@/service/admin.service";
import { superAxios } from "@/service/super.service";
import { configAxios } from "@/service/config.service";
import { useOptionStore } from "@/store/option";


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String as PropType<string>,
    default: () => "",
  },
},
  setup(__props) {

const props = __props

const router = useRouter();
const route = useRoute();
const userStore = userUseStore();
const adminStore = adminUseStore();
const superStore = superUseStore();
const i18n = useI18n();

const optionStore = useOptionStore();



const state = ref({
  userName: sessionStorage.getItem("username"),
  searchView: true,
  mainActive: false,
  adminActive: false,
  superActive: false,
  detailActive: false,
});

const adminState = computed(() => {
  if (
    sessionStorage.getItem("permission") === "admin" ||
    sessionStorage.getItem("permission") === "super"
  ) {
    return true;
  } else {
    return false;
  }
});

const superState = computed(() => {
  if (sessionStorage.getItem("permission") === "super") {
    return true;
  } else {
    return false;
  }
});

const dashboardChild = computed(() => {
  const list = [];
  if (userStore.deviceList[0]) {
    const child = _.map(userStore.deviceList, (item) => {
      const idx = userStore.findMac(item.mac_addr);
      const routerList = {
        title: item.site_name,
        view: idx === -1 ? true : false,
        active: state.value.detailActive,
        name: ROU_NAME.DETAIL,
        query: item.mac_addr,
      };
      return routerList;
    });
    list.push(...child);
  }

  return list;
});

const langChange = () => {
  if (i18n.locale.value === "ko") {
    i18n.locale.value = "en";
    localStorage.setItem("lang", i18n.locale.value);
    return;
  }
  if (i18n.locale.value === "en") {
    i18n.locale.value = "ko";
    localStorage.setItem("lang", i18n.locale.value);
    return;
  }
};

const tabs = computed(() => {
  let menu = [] as any[];
  if (superState.value) {
    menu = [
      {
        title: "Main Service",
        target: "main",
        active: state.value.mainActive,
        child: [{ title: "DashBoard", name: ROU_NAME.DASHBOARD }],
      },
      {
        title: "Admin Service",
        target: "admin",
        active: state.value.adminActive,
        child: [{ title: "Admin Page", name: ROU_NAME.ADMINPAGE }],
      },
      {
        title: "Super Service",
        target: "super",
        active: state.value.superActive,
        child: [{ title: "Super Page", name: ROU_NAME.SUPERPAGE }],
      },
    ];
    return menu;
  }
  if (adminState.value) {
    menu = [
      {
        title: "Main Service",
        target: "main",
        active: state.value.mainActive,
        child: [{ title: "DashBoard", name: ROU_NAME.DASHBOARD }],
      },
      {
        title: "Admin Service",
        target: "admin",
        active: state.value.adminActive,
        child: [{ title: "Admin Page", name: ROU_NAME.ADMINPAGE }],
      },
    ];
    return menu;
  }
  menu = [
    {
      title: "Main Service",
      target: "main",
      active: state.value.mainActive,
      child: [{ title: "DashBoard", name: ROU_NAME.DASHBOARD }],
    },
  ];
  return menu;
});

const userPageGo = () => {
  router.push({ name: ROU_NAME.ACCOUNT });
};

const titleDrop = (title: string) => {
  if (title === "Main Service") {
    state.value.mainActive = !state.value.mainActive;
  }
  if (title === "Admin Service") {
    state.value.adminActive = !state.value.adminActive;
  }
  if (title === "Super Service") {
    state.value.superActive = !state.value.superActive;
  }
};
const detailDrop = () => {
  state.value.detailActive = !state.value.detailActive;
};

const headerClear = () => {
  accountAxios.defaults.headers.common["Authorization"] = "";
  userAxios.defaults.headers.common["Authorization"] = "";
  adminAxios.defaults.headers.common["Authorization"] = "";
  superAxios.defaults.headers.common["Authorization"] = "";
  configAxios.defaults.headers.common["Authorization"] = "";
};

const logout = () => {
  sessionStorage.clear();
  deleteCookie("access_T");
  deleteCookie("refresh_T");
  headerClear();
  router.push({ name: ROU_NAME.LOGIN });
};

const settingGo = (mac: string) => {
  router.push({ name: ROU_NAME.SETTING, query: { mac: mac } });
};

watchEffect(() => {
  if (
    route.name === ROU_NAME.DETAIL ||
    route.name === ROU_NAME.SEARCH ||
    route.name === ROU_NAME.SETTING
  ) {
    state.value.searchView = false;
  } else {
    state.value.searchView = true;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("button", _hoisted_2, [
          _createVNode(AppImageVue, { name: "sidebar_icon" })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppImageVue, {
          name: "logo2",
          style: {"width":"300px","height":"56px"}
        })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(props.title), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            id: "language",
            checked: _unref(optionStore).$state.unitSystem === 'imperial',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(optionStore).changeUnitSystem()))
          }, null, 8, _hoisted_7),
          _createElementVNode("label", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(optionStore).$state.unitSystem === "metric" ? "Metric" : "Imperial"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            id: "language",
            checked: _unref(i18n).locale.value === 'ko',
            onClick: langChange
          }, null, 8, _hoisted_11),
          _createElementVNode("label", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(i18n).locale.value === "ko" ? "Korean" : "English"), 1)
          ])
        ])
      ]),
      (
        _unref(route).path === '/detail' &&
        (_unref(superStore).superPass() || _unref(adminStore).adminPass())
      )
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "setting-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (settingGo(String(_unref(route).query.mac))))
          }, [
            _createVNode(AppImageVue, { name: "settings_icon" })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", _hoisted_17, [
            _createVNode(AppImageVue, { name: "sidebar_close" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-grid",
            key: idx
          }, [
            _createElementVNode("button", {
              onClick: ($event: any) => (titleDrop(tab.title)),
              type: "button",
              role: "button",
              class: "first-tab",
              "data-bs-toggle": "collapse",
              "aria-expanded": "false",
              "data-bs-target": `#${tab.target}`,
              "aria-controls": `${tab.target}`
            }, [
              (tab.title === 'Main Service' && !tab.active)
                ? (_openBlock(), _createBlock(AppImageVue, {
                    key: 0,
                    style: {"margin-left":"20px"},
                    name: "mainservice_icon"
                  }))
                : (tab.title === 'Main Service' && tab.active)
                  ? (_openBlock(), _createBlock(AppImageVue, {
                      key: 1,
                      style: {"margin-left":"20px"},
                      name: "mainservice_icon_active"
                    }))
                  : _createCommentVNode("", true),
              (tab.title === 'Admin Service' && !tab.active)
                ? (_openBlock(), _createBlock(AppImageVue, {
                    key: 2,
                    style: {"margin-left":"20px"},
                    name: "adminservice_icon"
                  }))
                : _createCommentVNode("", true),
              (tab.title === 'Admin Service' && tab.active)
                ? (_openBlock(), _createBlock(AppImageVue, {
                    key: 3,
                    style: {"margin-left":"20px"},
                    name: "adminservice_icon_active"
                  }))
                : _createCommentVNode("", true),
              (tab.title === 'Super Service' && !tab.active)
                ? (_openBlock(), _createBlock(AppImageVue, {
                    key: 4,
                    style: {"margin-left":"20px"},
                    name: "superservice_icon"
                  }))
                : _createCommentVNode("", true),
              (tab.title === 'Super Service' && tab.active)
                ? (_openBlock(), _createBlock(AppImageVue, {
                    key: 5,
                    style: {"margin-left":"20px"},
                    name: "superservice_icon_active"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                style: {"margin-left":"20px"},
                class: _normalizeClass({
              active: tab.active,
            })
              }, _toDisplayString(tab.title), 3),
              (tab.title === 'Main Service' && !tab.active)
                ? (_openBlock(), _createBlock(AppImageVue, {
                    key: 6,
                    class: "drop-arrow",
                    name: "main_drop_icon"
                  }))
                : (tab.title === 'Main Service' && tab.active)
                  ? (_openBlock(), _createBlock(AppImageVue, {
                      key: 7,
                      class: "drop-arrow",
                      name: "main_drop_icon_active"
                    }))
                  : _createCommentVNode("", true),
              (tab.title === 'Admin Service' && !tab.active)
                ? (_openBlock(), _createBlock(AppImageVue, {
                    key: 8,
                    class: "drop-arrow",
                    name: "admin_drop_icon"
                  }))
                : (tab.title === 'Admin Service' && tab.active)
                  ? (_openBlock(), _createBlock(AppImageVue, {
                      key: 9,
                      class: "drop-arrow",
                      name: "admin_drop_icon_active"
                    }))
                  : _createCommentVNode("", true),
              (tab.title === 'Super Service' && !tab.active)
                ? (_openBlock(), _createBlock(AppImageVue, {
                    key: 10,
                    class: "drop-arrow",
                    name: "super_drop_icon"
                  }))
                : (tab.title === 'Super Service' && tab.active)
                  ? (_openBlock(), _createBlock(AppImageVue, {
                      key: 11,
                      class: "drop-arrow",
                      name: "super_drop_icon_active"
                    }))
                  : _createCommentVNode("", true)
            ], 8, _hoisted_19),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: "collapse multi-collapse",
                id: `${tab.target}`
              }, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("ul", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.child, (child, idx2) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "nav-item",
                        key: idx2
                      }, [
                        _createVNode(_component_router_link, {
                          class: _normalizeClass(["nav-link second-tap", {
                      disabled: child.view,
                    }]),
                          to: { name: child.name, query: { mac: child.query } }
                        }, {
                          default: _withCtx(() => [
                            (
                        child.title === 'DashBoard' &&
                        child.name !== _ctx.$route.name
                      )
                              ? (_openBlock(), _createBlock(AppImageVue, {
                                  key: 0,
                                  style: {"margin-left":"57px"},
                                  name: "dashboard_icon"
                                }))
                              : (
                        child.title === 'DashBoard' &&
                        child.name === _ctx.$route.name
                      )
                                ? (_openBlock(), _createBlock(AppImageVue, {
                                    key: 1,
                                    style: {"margin-left":"57px"},
                                    name: "dashboard_icon_active"
                                  }))
                                : _createCommentVNode("", true),
                            (
                        child.title === 'Admin Page' &&
                        child.name !== _ctx.$route.name
                      )
                              ? (_openBlock(), _createBlock(AppImageVue, {
                                  key: 2,
                                  style: {"margin-left":"57px"},
                                  name: "admin_icon"
                                }))
                              : (
                        child.title === 'Admin Page' &&
                        child.name === _ctx.$route.name
                      )
                                ? (_openBlock(), _createBlock(AppImageVue, {
                                    key: 3,
                                    style: {"margin-left":"57px"},
                                    name: "admin_icon_active"
                                  }))
                                : _createCommentVNode("", true),
                            (
                        child.title === 'Super Page' &&
                        child.name !== _ctx.$route.name
                      )
                              ? (_openBlock(), _createBlock(AppImageVue, {
                                  key: 4,
                                  style: {"margin-left":"57px"},
                                  name: "super_icon"
                                }))
                              : (
                        child.title === 'Super Page' &&
                        child.name === _ctx.$route.name
                      )
                                ? (_openBlock(), _createBlock(AppImageVue, {
                                    key: 5,
                                    style: {"margin-left":"57px"},
                                    name: "super_icon_active"
                                  }))
                                : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              style: {"margin-left":"20px"},
                              class: _normalizeClass({
                        active: child.name === _ctx.$route.name,
                      })
                            }, _toDisplayString(child.title), 3)
                          ]),
                          _: 2
                        }, 1032, ["class", "to"])
                      ]))
                    }), 128))
                  ]),
                  (tab.target === 'main')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("button", {
                          onClick: detailDrop,
                          type: "button",
                          role: "button",
                          class: "btn detail-btn",
                          "data-bs-toggle": "collapse",
                          "aria-expanded": "false",
                          "data-bs-target": `#detail`,
                          "aria-controls": `detail`
                        }, [
                          (_unref(route).path !== '/detail' && !state.value.detailActive)
                            ? (_openBlock(), _createBlock(AppImageVue, {
                                key: 0,
                                style: {"margin-left":"72px"},
                                name: "detail_icon"
                              }))
                            : (
                      (_unref(route).path === '/detail' && state.value.detailActive) ||
                      (_unref(route).path !== '/detail' && state.value.detailActive) ||
                      (_unref(route).path === '/detail' && !state.value.detailActive)
                    )
                              ? (_openBlock(), _createBlock(AppImageVue, {
                                  key: 1,
                                  style: {"margin-left":"72px"},
                                  name: "detail_icon_active"
                                }))
                              : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            class: _normalizeClass(["detail-btn-text", {
                      detailLinkActive: state.value.detailActive,
                      active: _unref(route).path === '/detail',
                    }]),
                            style: {"margin-left":"20px"}
                          }, "Detail", 2),
                          (!state.value.detailActive)
                            ? (_openBlock(), _createBlock(AppImageVue, {
                                key: 2,
                                class: "drop-arrow",
                                name: "detail_drop_icon"
                              }))
                            : (state.value.detailActive)
                              ? (_openBlock(), _createBlock(AppImageVue, {
                                  key: 3,
                                  class: "drop-arrow",
                                  name: "detail_drop_icon_active"
                                }))
                              : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("ul", _hoisted_28, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dashboardChild), (detail, idx3) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "nav-item detail-item",
                                    key: idx3
                                  }, [
                                    _createVNode(_component_router_link, {
                                      class: _normalizeClass(["nav-link detail-link", {
                              disabled: detail.view,
                              detailActive:
                                _unref(route).path === '/detail' &&
                                _unref(route).fullPath.substring(12, 24) ===
                                  detail.query,
                            }]),
                                      to: {
                              name: detail.name,
                              query: { mac: detail.query },
                            }
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(detail.title), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["class", "to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_21)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(AppImageVue, { name: "profile_icon_fill" }),
            _createElementVNode("span", _hoisted_32, _toDisplayString(state.value.userName), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("button", {
              class: "account-btn",
              onClick: userPageGo
            }, [
              _createVNode(AppImageVue, { name: "account_icon" })
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              class: "logout-btn",
              onClick: logout
            }, [
              _createVNode(AppImageVue, { name: "logout_icon" })
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})